import { useMemo } from 'react';
import { getUtcDate, useQuery } from '@common-fe/common-fe';

import { api } from '@/api';
import { DEFAULT_DATE_FORMAT } from '@/common/constants';
import { API_URL } from '@/dtos';

const QUERY_KEY = 'useGetPlanTerminationPropertiesQueryKey';

interface PlanTerminationPropertiesPayload {
  id: number;
  plan_id: number;
  termination_date: string;
  claim_last_date: string;
  coverage_end_date: string;
  hsa_transfer_of_assets: string;
}

export interface PlanTerminationProperties {
  id: string;
  planId: string;
  terminationDate: string;
  claimLastDate?: string;
  coverageEndDate?: string;
  hsaTransferOfAssets: string;
}

export const useGetPlanTerminationPropertiesQuery = (planId?: string) => {
  const { isLoading, isSuccess, data, refetch } = useQuery(
    [planId, QUERY_KEY],
    planId
      ? () =>
          api.get<PlanTerminationPropertiesPayload>(API_URL.PLANS_TERMINATION_PROPERTIES_BY_PLAN_ID(planId))
      : () => null
  );

  const formattedData: PlanTerminationProperties | undefined = useMemo(() => {
    if (!data?.data) return undefined;
    return {
      id: `${data?.data?.id}`,
      planId: `${data.data?.plan_id}`,
      terminationDate: getUtcDate(data.data?.termination_date).format(DEFAULT_DATE_FORMAT),
      claimLastDate: data.data?.claim_last_date
        ? getUtcDate(data.data.claim_last_date).format(DEFAULT_DATE_FORMAT)
        : undefined,
      coverageEndDate: data.data?.coverage_end_date
        ? getUtcDate(data.data.coverage_end_date).format(DEFAULT_DATE_FORMAT)
        : undefined,
      hsaTransferOfAssets: data.data?.hsa_transfer_of_assets || '',
    };
  }, [data]);

  return {
    data: data?.data,
    formattedData,
    isLoading,
    isSuccess,
    refetch,
  };
};
